import React from 'react'
import tw from 'tailwind-styled-components'
import {DataObjectId} from 'yougile-model'
import {cn} from '@containers/html-utils'
import {globals} from '@extensions/globals-base'
import {Icon} from '../../icon'
import {ProgressBar} from '../../progress-bar/progress-bar'

interface VotingItemViewCompProps {
  votes: {[userId: DataObjectId]: number[]}
  option: string
  idx: number
}

const TwPercent = tw.div`
  w-40
  text-primary
  text-right
  text-sm-semibold
  cursor-default
`
const TwOption = tw.div`
  text-sm-regular
  text-primary
  cursor-default
  overflow-hidden
  w-full
`

export const IconPoint = ({className}: {className?: string}) => {
  return (
    <div
      className={cn('bg-action-default w-12 h-12 rounded-50', className)}
    ></div>
  )
}

export const VotingItemViewComp = (props: VotingItemViewCompProps) => {
  const {votes = {}, option, idx} = props

  const data = Object.values(votes || {})

  const currentItemVotes = getVotesCurrent(idx, data)
  const totalVotes = getVotesNumber(data)

  const isSelected = votes[globals.currentUserId]?.includes(idx)

  return (
    <div className="flex gap-8 w-full">
      <div className="flex flex-col items-end">
        <TwPercent>{getPercent(currentItemVotes, totalVotes)}</TwPercent>

        {isSelected && (
          <div className="relative mt-auto">
            <Icon
              color="action-hover"
              icon={'IconCustomCircleSuccess'}
              className="mb-[-4px]"
            />
          </div>
        )}
      </div>

      <div className="flex flex-col items-start w-full gap-8 max-w-[calc(100%-48px)]">
        <TwOption>{option}</TwOption>

        <ProgressBar
          value={currentItemVotes}
          maxValue={Math.max(totalVotes, 1)}
          textPosition="none"
          className="w-full"
          bgColor="grey-l20"
          lineColor="interactive"
          size="8"
        />
      </div>
    </div>
  )
}

const getVotesNumber = (votesData: number[][]): number => {
  let total = 0
  for (const d of votesData) {
    total += d.length
  }

  return total
}

const getVotesCurrent = (currentIdx: number, votesData: number[][]): number => {
  let current = 0

  for (const d of votesData) {
    if (d.includes(currentIdx)) {
      current++
    }
  }
  return current
}

const getPercent = (curr = 0, total = 1): string => {
  total = Math.max(total, 1)
  const val = Math.floor((curr / total) * 100)

  return `${val}%`
}
